import { FeedItem } from 'types/feeds';

/**
 * The feed's keyword match: case-insensitive substring of the title or the description. An empty
 * keyword matches everything. Both the per-group search bar and the double-colon filter row apply
 * this, so the two never disagree about which items a keyword keeps.
 */
export function matchesFeedKeyword(item: FeedItem, keyword: string): boolean {
  if (!keyword) return true;
  const needle = keyword.toLowerCase();
  return item.title.toLowerCase().includes(needle) || Boolean(item.description?.toLowerCase().includes(needle));
}
